import NavigationMain from './NavigationMain.vue'

export default NavigationMain
